import React, { Component } from 'react'

export default class About extends Component {
    render() {
        return (
            <div>
                {/* <main id="main"> */}
                <section id="about">

<div class="container">
  <div class="row">

    <div class="col-lg-5 col-md-6">
      <div class="about-img wow fadeInRight animated animated">
        <img src="assets/img/about-img.png" alt=""/>
      </div>
    </div>
    

    <div class="col-lg-7 col-md-6">
      <div class="about-content wow fadeInLeft">
        <h2>About UicSoft</h2>
        <h3></h3>
          <p>UicSoft offers a professional tech Service to businesses. We will listen and talk through all of your ideas, starting with the 'dream idea' and working out what is affordable and achievable to suit your budget. If you are a new business just starting out, then we can help you achieve your new identity, whatever your budget. Let us help you SHINE in the busy marketplace. </p>
            <ul>
          <li><i class="ion-android-checkmark-circle"></i>  Smart, Light and Adaptive.</li>
          <li><i class="ion-android-checkmark-circle"></i> Stand out –We have uniqee Design.</li>
          <li><i class="ion-android-checkmark-circle"></i>More efficient – Outstanding webapp and andriod apps that makes your business standout.</li>
        </ul>
        <span class="text-top">Web Development <small>100%</small></span>
                                    <div class="progress">
                                        <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="60"
                                            aria-valuemin="0" aria-valuemax="100" style={{width: '100%'}}></div>
                                    </div>
                                    <span>Graphic Design <small>95%</small></span>
                                    <div class="progress">
                                        <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80"
                                            aria-valuemin="0" aria-valuemax="100" style={{width: '95%'}}></div>
                                    </div>
                                    <span>Video Editing <small>90%</small></span>
                                    <div class="progress">
                                        <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80"
                                            aria-valuemin="0" aria-valuemax="100" style={{width: '90%'}}></div>
                                    </div>
                                    <span>WordPress/Woo-commerce and Jumla <small>80%</small></span>
                                    <div class="progress">
                                        <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80"
                                            aria-valuemin="0" aria-valuemax="100" style={{width: '80%'}}></div>
                                    </div>
                                    <span>Search Engine Marketing <small>90%</small></span>
                                    <div class="progress">
                                        <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="90"
                                            aria-valuemin="0" aria-valuemax="100" style={{width: '90%'}}></div>
                                    </div>
                                    <span>Custom Branding <small>80%</small></span>
                                    <div class="progress">
                                        <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80"
                                            aria-valuemin="0" aria-valuemax="100" style={{width: '80%'}}></div>
                                    </div>
      </div>
    </div>
  </div>
</div>

</section>
                
           
    {/* </main> */}
                           
                            </div>
                      
                      
           
                      
        )
    }
}
